import { render, staticRenderFns } from "./cookie-policy.vue?vue&type=template&id=0045c888&scoped=true&"
import script from "./cookie-policy.vue?vue&type=script&lang=ts&"
export * from "./cookie-policy.vue?vue&type=script&lang=ts&"
import style0 from "./cookie-policy.vue?vue&type=style&index=0&id=0045c888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0045c888",
  null
  
)

export default component.exports